module.exports = __webpack_public_path__ + "static/media/construction-barrier.5b301ff1.svg";